import { useRouter } from "next/router";
import useSWRMutation from "swr/mutation";
import fetcher from "../api/fetcher";
import { ZENDESK_URL_MAPPING } from "../constants";
import { LanguageType, ZendeskUrl } from "../types";
import { handleZendeskRedirect } from "../utils/redirect.utils";

export const useRedirect = () => {
    const { locale } = useRouter() as { locale: LanguageType };

    const { trigger: triggerGetToken } = useSWRMutation(
        "/api/support-management/v1/support-system/token",
        (url: string) => fetcher(url)
    );

    const triggerZendeskRedirect = (key: ZendeskUrl) => {
        const url = ZENDESK_URL_MAPPING[locale]?.[key];
        if (!url) {
            console.error(
                `No Zendesk link could be found with: ${locale} ${key}`
            );
            return;
        }
        triggerGetToken().then((token: string) => {
            handleZendeskRedirect(token, url);
        });
    };

    return { triggerZendeskRedirect };
};
